// jshint esversion: 6
import $ from 'jquery'
import 'babel-polyfill'
import Foundation from './_foundation'
import 'motion-ui/dist/motion-ui'
import 'aos/dist/aos'
import './_acf-map'
import './_defer-oembed'
import './_defer-video'
import './_fixed-header'
import './_hero-slider'
import './_notification'
import './_scroll-to-top'
import './_skip-link-focus-fix'

// Slick
import './_slick'

// Off-canvas
import './_off-canvas'

// Fragment URLs
import './_fragmentURLs'

// Lodash
import throttle from 'lodash/throttle';

// init Foundation
$(document).foundation();

// Update header
var headerHeight = '';
$(window).on('resize', throttle( resizeWindow, 250, { 'leading': false } ) );
function resizeWindow() {
    if ( $(window).width() < 700 ) {
      let currentHeaderHeight = $('.site-header').height();
      if ( headerHeight != currentHeaderHeight ) {
          headerHeight = currentHeaderHeight;
          $('#content').css('padding-top',currentHeaderHeight);
      } 
      return true;
    } else if ( Foundation.MediaQuery.atLeast('medium') ) {
        $('#content').removeAttr('style');
        return false;
    }
}
resizeWindow();

// Push SVG to inline so we can edit them
$('img.svg').each(function() {
    let $this = $(this)
    $.get($this.attr('src'), function(data) {
        let $svg = $(data).find('svg').removeAttr('xmlns:a')
        $this.replaceWith($svg)
    }, 'xml')
})

// FAQ - accordion layout
$('.js-faq-question').click(function(e) {
    e.preventDefault();

    let $question = $(this);
    let $answer = $question.siblings( '.js-faq-answer' );

    $question.stop().toggleClass( 'is-open' );
    $answer.stop().slideToggle();
});

